/**
 * One-time relay for an invitation's accept secret between the registration
 * page and the account picker.
 *
 * When someone registers from an invite link (`/register?invitation=<id>#s=<secret>`),
 * the secret is only needed once — the moment they click Accept on the
 * account picker straight after signing up. It never touches the server
 * except in that one POST body, so we stash it in sessionStorage just long
 * enough to bridge the redirect, and take() removes it immediately so it
 * can't linger.
 */
const KEY_PREFIX = 'invite_secret_';

export function stashInvitationSecret(invitationId, secret) {
  if (!invitationId || !secret) return;
  try {
    sessionStorage.setItem(`${KEY_PREFIX}${invitationId}`, secret);
  } catch {
    // sessionStorage unavailable — the invitee falls back to "check your
    // email" messaging on the picker, same as if they'd lost the link.
  }
}

export function hasInvitationSecret(invitationId) {
  try {
    return Boolean(sessionStorage.getItem(`${KEY_PREFIX}${invitationId}`));
  } catch {
    return false;
  }
}

export function takeInvitationSecret(invitationId) {
  try {
    const key = `${KEY_PREFIX}${invitationId}`;
    const secret = sessionStorage.getItem(key);
    if (secret) sessionStorage.removeItem(key);
    return secret || null;
  } catch {
    return null;
  }
}
